import hash from "hash.js";
export class ProofKeyForCodeExchange {
    #storage;
    constructor(storage) {
        this.#storage = storage;
    }
    generateCodeVerifier() {
        const possible = "ABCDEFGHIJLMNOPQRSTUVWXYZabcdefghijlmnopqrstuvwxyz0123456789";
        return new Array(60)
            .fill(null)
            .reduce((acc) => acc + possible.charAt(Math.floor(Math.random() * possible.length)), "");
    }
    generateCodeChallenge(codeVerifier) {
        const digest = hash.sha256().update(codeVerifier).digest();
        return btoa(String.fromCharCode(...new Uint8Array(digest)))
            .replace(/=/g, "")
            .replace(/\+/g, "-")
            .replace(/\//g, "_");
    }
    generate() {
        const verifier = this.generateCodeVerifier();
        return {
            verifier,
            challenge: this.generateCodeChallenge(verifier),
        };
    }
}
